/*
 * Modal Routed Component
 */
(function() {
  'use strict';

  angular
    .module('tyallsApp')
    .config(['$stateProvider', function($stateProvider) {
      $stateProvider 
        .state('app.prop.prop-admin.audit-basket-console.create-audit-basket.add-auditor-dialog', {
          // url: '',  // modal -- no url
          params: { 
            propertyId: null,
            onSuccessfulEdit: null,
          }, // non-url params
          data: {
            authorities: []
          },
          resolve: {
            propertyId: ['$transition$', function($transition$) {
              return $transition$.params().propertyId;
            }],
            onSuccessfulEdit: ['$transition$', function($transition$) {
              return $transition$.params().onSuccessfulEdit;
            }]
          },
          onEnter: ['onSuccessfulEdit', 'propertyId', '$state', '$uibModal', function(onSuccessfulEdit, propertyId, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'app/entities/prop-admin/audit-basket-console/dialogs/add-auditor/add-auditor-dialog.html',
              controller: 'AddAuditorDialogController',
              controllerAs: '$ctrl',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                availableAuditors: [ 'UserService', function(UserService) {
                  return UserService.getAuditorsWithPropertyId(propertyId)
                    .then(function(response) {
                      return response.data;
                    })
                }],
                onSuccessfulEdit: { value: onSuccessfulEdit },
              }
            }).result.then(function(response) {
              // onSuccessfulEdit({
              //     auditors: response
              // });
              $state.go('^');
            }, function(reason) {
              $state.go('^');
            });
          }]
        });

    }]);

})();
